<template>
  <main id="register-wrapper">

    <div v-if="loadderforms" class="loading loading-double"></div>
    <div v-else id="registerpage">
      <breadcrumb
        :breadcrumb="[
          { title: 'Community', url: app_url, status: false },
          { title: 'HCID', url: app_url+'/hcid', status: false },
          { title: 'Register Profile', url: app_url+'/register-user', status: false },
        ]"
      ></breadcrumb>
      <div class="container-fluid title-row text-center">
        <div class="container">
          <div class="row py-3">
            <div class="col">
              <h2>Register Profile</h2>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid title-row-info text-center">
        <div class="container">
          <div class="row py-3">
            <div class="colpage">
                <div class="pageform" :class="{active : page == 1}">
                    <span class="numberpage">1</span>
                    <!-- <span class="infopage">Informasi Data Diri</span> -->
                </div>
                <span class="arrow-right"><img :src="base_url+'/images/arrow-right.png'" alt="arrow"></span>
                <div class="pageform" :class="{active : page == 2}">
                    <span class="numberpage">2</span>
                </div>
                <span class="arrow-right"><img :src="base_url+'/images/arrow-right.png'" alt="arrow"></span>
                <div class="pageform" :class="{active : page == 3}">
                    <span class="numberpage">3</span>
                </div>
                <span class="arrow-right"><img :src="base_url+'/images/arrow-right.png'" alt="arrow"></span>
                <div class="pageform" :class="{active : page == 4}">
                    <span class="numberpage">4</span>
                </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container py-5" id="dataform">
        <div class="row justify-content-center">
          <div class="col-md-12">
                <form
                method="POST"
                @submit.prevent="onSubmit"
                @keydown="form.errors.clear($event.target.name)"
                enctype="multipart/form-data"
            >
            <div class="card" v-if="page == 1">
              <div class="card-body">
                  <div class="form-group row" :id="form.errors.has('name') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="nama">Nama</label>
                      <input
                        type="text"
                        class="form-control form-register"
                        id="nama"
                        aria-describedby="nama"
                        v-model="form.name"
                        placeholder="Masukkan Nama"
                      />
                        <span
                        class="help-block"
                        v-if="form.errors.has('name')"
                        v-text="form.errors.get('name')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('email') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="email">Email</label>
                      <input
                        type="email"
                        class="form-control form-register"
                        aria-describedby="email"
                        placeholder="Masukkan Email"
                        v-model="form.email"
                        disabled
                      />
                        <span
                        class="help-block"
                        v-if="form.errors.has('email')"
                        v-text="form.errors.get('email')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('phone') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="hp">No. Handphone</label>
                        <div class="phonebox">
                            <span class="input62">+62</span>
                            <input
                                type="number"
                                class="form-control form-register"
                                id="hp"
                                aria-describedby="hp"
                                placeholder="8XXXXXXXX"
                                v-model="form.phone"
                                disabled
                            />
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('phone')"
                        v-text="form.errors.get('phone')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('birth_place') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="tempat-lahir">Tempat Lahir</label>
                      <input
                        type="text"
                        class="form-control form-register"
                        id="tempat-lahir"
                        aria-describedby="tempat-lahir"
                        placeholder="Masukkan Tempat Lahir"
                        v-model="form.birth_place"
                      />
                        <span
                        class="help-block"
                        v-if="form.errors.has('birth_place')"
                        v-text="form.errors.get('birth_place')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('birth_date') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="tanggal-lahir">Tanggal Lahir</label>
                      <input
                        type="date"
                        class="form-control form-register"
                        id="tanggal-lahir"
                        aria-describedby="tanggal-lahir"
                        placeholder="Masukkan Tanggal Lahir"
                        v-model="form.birth_date"
                      />
                        <span
                        class="help-block"
                        v-if="form.errors.has('birth_date')"
                        v-text="form.errors.get('birth_date')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div v-if="submitLoader" class="loading loading-double"></div>
                    <button v-else  type="button" @click="nextAction(2); registerProfile1Tracker('Next');" class="btn mx-2 btn-red">Selanjutnya</button>
                  </div>
              </div>
            </div>
            <div class="card" v-if="page == 2">
              <div class="card-body">
                <div class="form-group row" :id="form.errors.has('province_id') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="province_id">Provinsi Domisili</label>
                        <div class="custom_vselect custom_vselect-large">
                            <v-select
                                :options="provinces"
                                label="name"
                                :placeholder="provincePlaceholder"
                                @input="changeProvince($event,'province_id','provinceName')"
                                v-model="province_id"
                            >
                            </v-select>
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('province_id')"
                        v-text="form.errors.get('province_id')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('city_id') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="city_id">Kota Domisili</label>
                        <div class="custom_vselect custom_vselect-large">
                        <v-select
                            :options="cities"
                            label="name"
                            :placeholder="cityPlaceholder"
                            @input="changeCity($event,'city_id','cityName')"
                            v-model="city_id"
                        >
                        </v-select>
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('city_id')"
                        v-text="form.errors.get('city_id')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('address') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="alamat">Alamat Domisili</label>
                      <input
                        type="text"
                        class="form-control form-register"
                        id="alamat"
                        aria-describedby="alamat"
                        placeholder="Masukkan Alamat Domisili"
                        v-model="form.address"
                      />
                        <span
                        class="help-block"
                        v-if="form.errors.has('address')"
                        v-text="form.errors.get('address')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('gender') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="gender">Gender</label>
                      <select
                        class="form-control form-register"
                        id="gender"
                        aria-describedby="gender"
                        v-model="form.gender"
                      >
                        <option value="" selected disabled>Pilih Gender</option>
                        <option value="pria">Male</option>
                        <option value="wanita">Female</option>
                      </select>
                        <span
                        class="help-block"
                        v-if="form.errors.has('gender')"
                        v-text="form.errors.get('gender')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('blood_type') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="blood_type">Golongan Darah</label>
                      <select
                        class="form-control form-register"
                        id="blood_type"
                        aria-describedby="blood_type"
                        v-model="form.blood_type"
                      >
                        <option value="" selected disabled>Pilih Golongan Darah</option>
                        <option value="A">A</option>
                        <option value="B">B</option>
                        <option value="AB">AB</option>
                        <option value="O">O</option>
                      </select>
                        <span
                        class="help-block"
                        v-if="form.errors.has('blood_type')"
                        v-text="form.errors.get('blood_type')"
                        >
                        </span>
                    </div>
                  </div>
                  <div  v-if="submitLoader" class="row justify-content-center">
                    <div class="loading loading-double"></div>
                  </div>
                  <div v-else class="row justify-content-center">
                    <button  type="button" @click="backAction(1); registerProfile2Tracker('Return');" class="btn mx-2 btn-white">Kembali</button>
                    <button  type="button" @click="nextAction(3); registerProfile2Tracker('Next');" class="btn mx-2 btn-red">Selanjutnya</button>
                  </div>
              </div>
            </div>
            <div class="card" v-if="page == 3">
              <div class="card-body">
                  <div class="form-group row" :id="form.errors.has('bike_category') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="type">Kategori Motor</label>
                        <div class="custom_vselect custom_vselect-large">
                        <v-select
                            :options="motorCategories"
                            label="title"
                            :placeholder="motorCategoryPlaceholder"
                            @input="changeMotorCategory($event,'bike_category','motor_id')"
                            v-model="bike_category"
                        >
                        </v-select>
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('bike_category')"
                        v-text="form.errors.get('bike_category')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('motor_id') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="type">Varian Motor</label>
                        <div  v-if="form.bike_category != 'lain-lain'" class="custom_vselect custom_vselect-large">
                        <v-select
                            :options="varianMotors"
                            label="title"
                            :placeholder="varianMotorPlaceholder"
                            @input="changeVarianMotor($event,'motor_id','motorName')"
                            v-model="motor_id"
                        >
                        </v-select>
                        </div>
                        <div v-else>
                            <input
                                type="text"
                                class="form-control form-register"
                                id="motor_id"
                                aria-describedby="motor_id"
                                v-model="form.motor_id"
                                placeholder="Varian Motor"
                            />
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('motor_id')"
                        v-text="form.errors.get('motor_id')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('motor_year') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="type">Tahun Pembuatan Motor</label>
                        <div class="custom_vselect custom_vselect-large">
                          <v-select
                              :options="years"
                              label="title"
                              placeholder="Pilih tahun pembuatan motor"
                              :disabled="years.length === 0"
                              v-model="form.motor_year"
                          >
                          </v-select>
                        </div>
                        <span
                          class="help-block"
                          v-if="form.errors.has('motor_year')"
                          v-text="form.errors.get('motor_year')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('no_motor') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="no-rangka">No Rangka Motor</label>
                      <input
                        type="text"
                        class="form-control form-register"
                        id="no-rangka"
                        aria-describedby="no-rangka"
                        placeholder="Masukkan nomor rangka motor"
                        v-model="form.no_motor"
                        v-mask="'NNNN-NNNN-NNNN-NNNN-N'"
                      />
                        <span class="note">17 Karakter. <a class="text-red" @click="showImage">Klik disini</a> untuk menemukan nomor rangka</span>
                        <span
                        class="help-block"
                        v-if="form.errors.has('no_motor')"
                        v-text="form.errors.get('no_motor')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('sim_id') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="sim_id">No SIM</label>
                      <input
                        type="text"
                        class="form-control form-register"
                        id="sim_id"
                        aria-describedby="sim_id"
                        placeholder="Masukkan nomor SIM anda minimal 10 karakter"
                        v-model="form.sim_id"
                        v-mask="'####-####-####-####'"
                      />
                        <span
                        class="help-block"
                        v-if="form.errors.has('sim_id')"
                        v-text="form.errors.get('sim_id')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('hobi') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="hobi">Hobi</label>
                        <div class="custom_vselect custom_vselect-large">
                        <v-select
                            :options="hobbies"
                            multiple
                            :placeholder="hobiPlaceholder"
                            @input="changeHobby($event,'hobi')"
                            v-model="hobi"
                        >
                        </v-select>
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('hobi')"
                        v-text="form.errors.get('hobi')"
                        >
                        </span>
                    </div>
                  </div>
                  <div  v-if="submitLoader" class="row justify-content-center">
                    <div class="loading loading-double"></div>
                  </div>
                  <div v-else class="row justify-content-center">
                    <button  type="button" @click="backAction(2); registerProfile3Tracker('Return');" class="btn mx-2 btn-white">Kembali</button>
                    <button  type="button" @click="nextAction(4); registerProfile3Tracker('Next');" class="btn mx-2 btn-red">Selanjutnya</button>
                  </div>
              </div>
            </div>
            <div class="card" v-if="page == 4">
              <div class="card-body">
                <h3 class="title">Info Komunitas</h3>
                  <div class="form-group row" :id="form.errors.has('club_provinsi1') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="provinsi-komunitas">Provinsi</label>
                        <div class="custom_vselect custom_vselect-large">
                            <v-select
                                :options="provinces"
                                label="name"
                                :placeholder="provinceClub1Placeholder"
                                @input="changeProvince($event,'club_provinsi1','club1ProvinceName')"
                                v-model="club_provinsi1"
                            >
                            </v-select>
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('club_provinsi1')"
                        v-text="form.errors.get('club_provinsi1')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('club_city1') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="kota-komunitas">Kota</label>
                        <div class="custom_vselect custom_vselect-large">
                        <v-select
                            :options="cities"
                            label="name"
                            :placeholder="cityClub1Placeholder"
                            @input="changeCity($event,'club_city1','club1CityName')"
                            v-model="club_city1"
                        >
                        </v-select>
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('club_city1')"
                        v-text="form.errors.get('club_city1')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('motor_category_club1') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="type">Kategori Motor</label>
                        <div class="custom_vselect custom_vselect-large">
                        <v-select
                            :options="motorCategories"
                            label="title"
                            :placeholder="motorCategoryPlaceholderClub1"
                            @input="changeMotorCategory($event,'motor_category_club1','club_tipe_motor1')"
                            v-model="motor_category_club1"
                        >
                        </v-select>
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('motor_category_club1')"
                        v-text="form.errors.get('motor_category_club1')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('club_tipe_motor1') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="type">Varian Motor</label>
                        <div  v-if="form.motor_category_club1 != 'lain-lain'" class="custom_vselect custom_vselect-large">
                        <v-select
                            :options="varianMotors"
                            label="title"
                            :placeholder="varianMotorPlaceholderClub1"
                            @input="changeVarianMotor($event,'club_tipe_motor1','club1MotorName')"
                            v-model="club_tipe_motor1"
                        >
                        </v-select>
                        </div>
                        <div v-else>
                            <input
                                type="text"
                                class="form-control form-register"
                                id="club_tipe_motor1"
                                aria-describedby="club_tipe_motor1"
                                v-model="form.club_tipe_motor1"
                                placeholder="Varian Motor"
                            />
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('club_tipe_motor1')"
                        v-text="form.errors.get('club_tipe_motor1')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row" :id="form.errors.has('club_name1') ? 'error-field' : false">
                    <div class="col">
                      <label class="label-form" for="nama-komunitas"
                        >Nama Komunitas</label
                      >
                       <div class="custom_vselect custom_vselect-large">

                        <auto-search
                        class="auto-search"
                        v-model="club_name1"
                        :data="clubs"
                        :serializer="(item) => item.name"
                        @hit="changeClub($event,'club_name1')"
                        :placeholder="clubPlaceholder"
                        />
                        </div>
                        <span class="note">Anda bisa mencari komunitas atau membuat nama komunitas baru dengan mengetik pada kotak input di atas ini.</span>
                        <span
                        class="help-block"
                        v-if="form.errors.has('club_name1')"
                        v-text="form.errors.get('club_name1')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-check form-group row">
                    <div class="col">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        id="checkbox-komunitas-1"
                        v-model="form.hasOtherCommunity"
                      />
                      <label class="form-check-label" for="checkbox-komunitas-1"
                        >Apakah anda memiliki komunitas lain ?</label
                      >
                      <small
                        id="checkboxKomunitasHelp"
                        class="form-text text-muted"
                      ></small>
                    </div>
                  </div>
                  <div v-if="form.hasOtherCommunity">
                    <div class="form-group row">
                      <div class="col">
                        <label class="label-form" for="provinsi-komunitas-2"
                          >Provinsi ke 2</label
                        >
                        <div class="custom_vselect custom_vselect-large">
                            <v-select
                                :options="provinces"
                                label="name"
                                :placeholder="provinceClub2Placeholder"
                                @input="changeProvince($event,'club_provinsi2','club2ProvinceName')"
                                v-model="club_provinsi2"
                            >
                            </v-select>
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('club_provinsi2')"
                        v-text="form.errors.get('club_provinsi2')"
                        >
                        </span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col">
                        <label class="label-form" for="kota-komunitas-2">Kota ke 2</label>
                        <div class="custom_vselect custom_vselect-large">
                        <v-select
                            :options="cities"
                            label="name"
                            :placeholder="cityClub2Placeholder"
                            @input="changeCity($event,'club_city2','club2CityName')"
                            v-model="club_city2"
                        >
                        </v-select>
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('club_city2')"
                        v-text="form.errors.get('club_city2')"
                        >
                        </span>
                      </div>
                    </div>

                  <div class="form-group row">
                    <div class="col">
                      <label class="label-form" for="type">Kategori Motor</label>
                        <div class="custom_vselect custom_vselect-large">
                        <v-select
                            :options="motorCategories"
                            label="title"
                            :placeholder="motorCategoryPlaceholderClub2"
                            @input="changeMotorCategory($event,'motor_category_club2','club_tipe_motor2')"
                            v-model="motor_category_club2"
                        >
                        </v-select>
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('motor_category_club2')"
                        v-text="form.errors.get('motor_category_club2')"
                        >
                        </span>
                    </div>
                  </div>
                  <div class="form-group row">
                    <div class="col">
                      <label class="label-form" for="type">Varian Motor</label>
                        <div  v-if="form.motor_category_club2 != 'lain-lain'" class="custom_vselect custom_vselect-large">
                        <v-select
                            :options="varianMotors"
                            label="title"
                            :placeholder="varianMotorPlaceholderClub2"
                            @input="changeVarianMotor($event,'club_tipe_motor2','club2MotorName')"
                            v-model="club_tipe_motor2"
                        >
                        </v-select>
                        </div>
                        <div v-else>
                            <input
                                type="text"
                                class="form-control form-register"
                                id="club_tipe_motor2"
                                aria-describedby="club_tipe_motor2"
                                v-model="form.club_tipe_motor2"
                                placeholder="Varian Motor"
                            />
                        </div>
                        <span
                        class="help-block"
                        v-if="form.errors.has('club_tipe_motor2')"
                        v-text="form.errors.get('club_tipe_motor2')"
                        >
                        </span>
                    </div>
                  </div>
                    <div class="form-group row">
                      <div class="col">
                        <label class="label-form" for="nama-komunitas-2"
                          >Nama Komunitas ke 2</label
                        >
                       <div class="custom_vselect custom_vselect-large">
                        <auto-search
                        class="auto-search"
                        v-model="club_name2"
                        :data="clubs"
                        :serializer="(item) => item.name"
                        @hit="changeClub($event,'club_name2')"
                        :placeholder="clubPlaceholder2"
                        />
                        </div>
                        <span class="note">Anda bisa mencari komunitas atau membuat nama komunitas baru dengan mengetik pada kotak input di atas ini.</span>
                        <span
                        class="help-block"
                        v-if="form.errors.has('club_name2')"
                        v-text="form.errors.get('club_name2')"
                        >
                        </span>
                      </div>
                    </div>
                  </div>
                  <br />
                  <div class="form-check form-group row" :id="form.errors.has('agree') ? 'error-field' : false">
                    <div class="col">
                      <input type="checkbox" class="form-check-input" id="term" v-model="form.agree" />
                      <label class="form-check-label" for="term" v-html="pagePrivacy.summary"></label>
                      <span
                      class="help-block"
                      v-if="form.errors.has('agree')"
                      v-text="form.errors.get('agree')"
                      >
                      </span>
                    </div>
                  </div>
                  <div v-if="submitLoader" class="row justify-content-center">
                    <div class="loading loading-double"></div>
                  </div>
                  <div v-else class="row justify-content-center">
                    <button  type="button" @click="backAction(3); registerProfile4Tracker('Return');" class="btn mx-2 btn-white">Kembali</button>
                    <button  type="button" @click="nextAction(5); registerProfile4Tracker('Next');" class="btn mx-2 btn-red">Simpan</button>
                  </div>
              </div>
            </div>
            </form>
          </div>
        </div>
      </div>
      <popup-image ref="popupImage"></popup-image>
    </div>
  </main>
</template>
<script>
import { isMobile } from "mobile-device-detect";
import BreadCrumb from "../../widget/BreadCrumb";
import PopupImage from '../../widget/PopupImage'
import 'vue-select/dist/vue-select.css';
import vSelect from "vue-select";
import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import { sha256, sha224 } from 'js-sha256';


export default {
  components: {
    breadcrumb: BreadCrumb,
    "v-select": vSelect,
    "popup-image": PopupImage,
    "auto-search": VueBootstrapTypeahead,
  },
  data() {
    return {
        base_url:'',
        app_url:'',
        api_url:'',
        main_site_url:main_site_url,
        mobile: false,
        page: 1,
        token:'',
        provinces:[],
        province_id:'',
        provinceName:'',
        provincePlaceholder:'Pilih Provinsi',
        club_provinsi1:'',
        club1ProvinceName:'',
        provinceClub1Placeholder:'Pilih Provinsi',
        club_provinsi2:'',
        club2ProvinceName:'',
        provinceClub2Placeholder:'Pilih Provinsi',
        cities:[],
        city_id:'',
        cityName:'',
        cityPlaceholder:'Pilih Kota',
        club_city1:'',
        club1CityName:'',
        cityClub1Placeholder:'Pilih Kota',
        club_city2:'',
        club2CityName:'',
        cityClub2Placeholder:'Pilih Kota',
        motor_types:[],
        bike_category:'',
        club_tipe_motor1:'',
        club1MotorName:'',
        club_tipe_motor2:'',
        club2MotorName:'',
        motorPlaceholder:'Pilih Tipe Motor',
        clubs:[],
        club_name1:'',
        club_name2:'',
        clubPlaceholder:'Pilih Nama Komunitas',
        clubPlaceholder2:'Pilih Nama Komunitas',
        hobbies:['Foto','Video','Grafiti','Food','Music','Sport','Modif','Movies','Traveling'],
        hobi:'',
        hobiPlaceholder:'Pilih Hobi',
        varianMotors:[],
        motor_id:'',
        motorName: '',
        varianMotorPlaceholder:'Pilih Varian Motor',
        varianMotorPlaceholderClub1:'Pilih Varian Motor',
        varianMotorPlaceholderClub2:'Pilih Varian Motor',
        motorCategories:[],
        motor_category:'',
        motor_category_club1:'',
        motor_category_club2:'',
        motorCategoryPlaceholder:'Pilih Kategori Motor',
        motorCategoryPlaceholderClub1:'Pilih Kategori Motor',
        motorCategoryPlaceholderClub2:'Pilih Kategori Motor',
        loadderforms:true,
        submitLoader:false,
        tokenForm: new Form({
            token:'',
        }),
        user:null,
        tmpform:null,
        years: [],
        year: null,
        form: new Form({
                _token : token,
                name:'',
                email:'',
                phone:'',
                birth_date:'',
                birth_place:'',
                province_id:'',
                city_id:'',
                address:'',
                gender:'',
                blood_type:'',
                bike_category:'',
                motor_id:'',
                no_motor:'',
                sim_id:'',
                hobi:'',
                club_name1:'',
                club_provinsi1:'',
                club_city1:'',
                club_tipe_motor1:'',
                motor_category_club1:'',
                club_name2:'',
                club_provinsi2:'',
                club_city2:'',
                club_tipe_motor2:'',
                motor_category_club2:'',
                agree:'',
                ref:'',
                motor_year: ''
            }),
            pagePrivacy: {},
        };
  },
  watch: {
    club_name1(newQuery) {
        this.form.club_name1 = newQuery;
        axios.get(api_url+`/static/community?name=${newQuery}`)
          .then((response) => {
            this.clubs = response.data.data.community;
          });
    },
    club_name2(newQuery) {
        this.form.club_name2 = newQuery;
        axios.get(api_url+`/static/community?name=${newQuery}`)
          .then((response) => {
            this.clubs = response.data.data.community;
          });
    },
  },
  created() {
    this.base_url = base_url;
    this.app_url = app_url;
    this.api_url = api_url;
    this.mobile = isMobile;;
    this.form.ref = localStorage.getItem('utmname') ?? '-';
    if(localStorage.getItem('user') != null){
        this.user = JSON.parse(localStorage.getItem('user'));
        this.page = this.user.current_step + 1;
        if(this.page >= 4){
          this.page = 4;
        }
        this.defaulUser();
        this.fetchPagePrivacy();
        this.getProvince();
        this.getMotor();
        this.getMotorCategory()
        this.getYear();
    }
    // if (localStorage.getItem('socmed') != null) {
    //   var socmed = localStorage.getItem('socmed');
    //   var data = {
    //       'event': 'Register Step 1',
    //       'eventCategory': 'Registration',
    //       'eventAction': 'Select register method',
    //       'eventLabel': socmed,
    //   };
    //   dataLayer.push(data);
    // }
  },
  methods: {
    // GTM Tracker
    trackRegistrationEvenDatalayer(eventStep, profileNumber, eventLabel, eventData) {
      const tracker = {
        'event': `registerStep${eventStep}`,
        'eventDetail.category': 'Registration',
        'eventDetail.action': `Register Profile ${profileNumber}`,
        'eventDetail.label': eventLabel || 'Next', // Default to 'Next' if eventLabel is not provided
        ...eventData // Spread the provided eventData object
      };

      console.log(`registerStep${eventStep} =`, tracker);
      dataLayer.push(tracker);
    },

    registerProfile1Tracker(eventLabel) {
      const eventData = {
        'email': sha256(this.form.email),
        'phone': sha256(`62${this.form.phone}`),
        'birthPlace': sha256(this.form.birth_place || ''),
        'dateOfBirth': sha256(this.form.birth_date || ''),
      };
      this.trackRegistrationEvenDatalayer(5, 1, eventLabel, eventData);
    },

    registerProfile2Tracker(eventLabel) {
      const eventData = {
        'province': this.provinceName || '',
        'city': this.cityName || '',
        'address': sha256(this.form.address || ''),
        'gender': sha256(this.form.gender == 'pria' ? 'Male' : 'Female'),
        'bloodType': sha256(this.form.blood_type || ''),
      };
      this.trackRegistrationEvenDatalayer(6, 2, eventLabel, eventData);
    },

    registerProfile3Tracker(eventLabel) {
      const eventData = {
        'motorCategory': this.uppercaseFirstLetter(this.form.bike_category || ''), // or Matic
        'motorVariant': (this.form.bike_category !== 'lain-lain') ? this.motorName : this.form.motor_id, // or Vario 125
        'machineNumber': sha256(this.form.no_motor || ''),
        'simNumber': sha256(this.form.sim_id || ''),
        'hobby': this.form.hobi || '', // or Photo, etc.
      };
      this.trackRegistrationEvenDatalayer(7, 3, eventLabel, eventData);
    },

    registerProfile4Tracker(eventLabel) {
      const eventData = {
        'selectedProvince': this.club1ProvinceName || '',
        'selectedCity': this.club1CityName || '',
        'motorCategory': this.uppercaseFirstLetter(this.form.motor_category_club1 || ''), // or Matic
        'motorVariant': (this.form.motor_category_club1 !== 'lain-lain') ? this.club1MotorName : this.form.club_tipe_motor1, // or Vario 125
        'communityName': this.form.club_name1 || '',
      };
      this.trackRegistrationEvenDatalayer(8, 4, eventLabel, eventData);
    },
    // End of GTM Tracker

    showImage(){
        var data = {
            title : 'STNK',
            asset : {
                original : base_url+'/images/stnk.png'
            }
        }
        this.$refs.popupImage.show(data)
    },
    defaulUser(){
      const {
          name = '',
          email = '',
          phone = '',
          birth_date = '',
          birth_place = '',
          province_id = '',
          city_id = '',
          address = '',
          gender = '',
          bike_type = null,
          motor_id = '',
          bike_category = '',
          no_motor = '',
          hobby = '',
          club_id1 = '',
          club_province_id1 = '',
          club_city_id1 = '',
          club_bike_id1 = '',
          motor_category_club1 = '',
          club_bike_type1 = '',
          club_id2 = '',
          club_province_id2 = '',
          club_city_id2 = '',
          club_motor_id2 = '',
          motor_category_club2 = '',
          club_bike_type2 = '',
          driving_id = '',
          blood_type = '',
          province = null,
          city = null,
          motor_year = '',
      } = this.user;

      this.form.name = name;
      this.form.email = email;
      this.form.phone = phone;
      this.form.birth_date = birth_date;
      this.form.birth_place = birth_place;
      this.form.province_id = province?.id || '';
      this.form.city_id = city?.id || '';
      this.form.address = address;
      this.form.gender = gender;
      this.form.motor_id = (bike_type && bike_type.type === 'lain-lain') ? bike_type.name || '' : motor_id;
      this.form.bike_category = bike_category;
      this.form.no_motor = no_motor;
      this.form.motor_year = motor_year;
      this.form.hobi = hobby;
      this.hobi = hobby ? hobby.split(',') : [];
      this.form.club_name1 = club_id1;
      this.form.club_provinsi1 = club_province_id1;
      this.form.club_city1 = club_city_id1;
      this.form.club_tipe_motor1 = (motor_category_club1 === 'lain-lain') ? club_bike_type1 : club_bike_id1;
      this.form.motor_category_club1 = motor_category_club1;
      this.form.club_name2 = club_id2;
      this.form.club_provinsi2 = club_province_id2;
      this.form.club_city2 = club_city_id2;
      this.form.club_tipe_motor2 = (motor_category_club2 === 'lain-lain') ? club_bike_type2 : club_motor_id2;
      this.form.motor_category_club2 = motor_category_club2;
      this.form.sim_id = driving_id;
      this.form.blood_type = blood_type;
      this.provincePlaceholder = province?.name || 'Pilih Provinsi';
      this.provinceName = province?.name || '';
      this.cityPlaceholder = city?.name || 'Pilih Kota';
      this.cityName = city?.name || '';
      this.form.motor_category = bike_category;
      this.motorCategoryPlaceholder = bike_category;
      this.clubPlaceholder = club_id1;
      this.clubPlaceholder2 = club_id2;
      this.motorCategoryPlaceholderClub1 = motor_category_club1;
      this.varianMotorPlaceholderClub1 = (motor_category_club1 === 'lain-lain') ? club_bike_type1 : '';
      this.motorCategoryPlaceholderClub2 = motor_category_club2;
      this.varianMotorPlaceholderClub2 = (motor_category_club2 === 'lain-lain') ? club_bike_type2 : '';
      this.provinceClub1Placeholder = club_province_id1 || 'Pilih Provinsi';
      this.club1ProvinceName = club_province_id1 || '';
      this.cityClub1Placeholder = club_city_id1 || 'Pilih Kota';
      this.club1CityName = club_city_id1 || '';
      this.provinceClub2Placeholder = club_province_id2 || 'Pilih Provinsi';
      this.club2ProvinceName = club_province_id2 || '';
      this.cityClub2Placeholder = club_city_id2 || 'Pilih Kota';
      this.club2CityName = club_city_id2 || '';
      this.varianMotorPlaceholder = (bike_type && bike_type.name) || '';
    },
    getToken(token) {
      this.loadderforms = true;
      this.tokenForm.token = token;
      this.tokenForm.post(api_url+"/auth/social/get-token")
        .then((response) => {
           this.token = response.data.token;
           localStorage.setItem('token',this.token)
        })
        .catch((response) => {
            localStorage.clear();
            window.location.href = this.app_url + '/login'
        });
    },
    onSubmit(page) {
      this.submitLoader = true;
      var target = page - 1;
      var app = this;
      this.tmpform = this.form;
      // console.log(this.form);
      this.form.post(api_url+"/member/register/step/"+target)
        .then((response) => {
            this.form._token = token;
            this.submitLoader = false;
            if(response.status){
              this.user = response.member;
              localStorage.setItem('user',JSON.stringify(response.member))
              this.defaulUser();
              if(response.member.current_step == 4){
                localStorage.setItem('register-success',JSON.stringify(response.member))
                localStorage.setItem('hcprfhcid', response.member.hcid)
                localStorage.setItem('hcprfencphnmbr', sha256(`62${response.member.phone}`))
                localStorage.setItem('hcprfenceml', sha256(response.member.email))
                window.location.href = this.app_url + '/success-register'
              }else{
                this.page = page;
                if(this.page == 4){
                  this.getClub();
                }
                this.$scrollTo('#dataform')
              }
            }
        })
        .catch((response) => {
            console.log(response);
            this.submitLoader = false;
            this.form = this.tmpform;
            app.$scrollTo('#error-field')
            console.log("ERROR");
          // if(response.expired){
          //     window.location.href = app_url+'/login';
          // }else{
          //   this.submitLoader = false;
          //   this.form = this.tmpform;
          //   app.$scrollTo('#error-field')
          //   console.log("ERROR");
          // }
        });
    },
    nextAction(page) {
      this.onSubmit(page);
    },
    backAction(page){
      this.page = page;
    },
    async fetchPagePrivacy() {
        try {
            const response = await axios.get(
                `${api_mainsite_url}/page/type/persetujuan-privasi`
            );

            this.pagePrivacy = response.data;
        } catch (error) {
            console.log(error);
        }
    },
    getYear() {
      const currentYear = new Date().getFullYear();

      const years = [];

      for (let i = currentYear; i >= 1948; i--) {
        years.push(i);
      }

      this.years = years;
    },
    changeYear(event) {
      console.log(event)
      if (event) {
        this.form.motor_year = event;
      } else {
        this.form.motor_year = ''
      }
    },
    getProvince() {
            this.loadderforms = true;
            axios.get(api_url+'/static/province')
                .then(response => {
                    this.provinces = response.data.data.provincy;
                    this.loadderforms = false;
                }).catch(error => {
                    console.log(error);
                });
    },
    changeProvince(event,label,name){
      if(event){
        this.form[label] = event._id;
        this[name] = event.name;
        this.getCity(event._id);
      }else{
        this.form[label] = null;
      }
    },
    getCity(province) {
            axios.get(api_url+'/static/city/'+province)
                .then(response => {
                    this.cities = response.data.data.city;
                }).catch(error => {
                    console.log(error);
                });
    },
    changeCity(event,label,name){
      if(event){
        this.form[label] = event._id;
        this[name] = event.name;
      }else{
        this.form[label] = null;
      }
    },
    changeHobby(event,label){
        if(event.length > 3) {
            event.pop()
        }else{
            this.form.hobi = event.toString();
        }
    },
    getMotor() {
            axios.get(api_url+'/static/motor')
                .then(response => {
                    this.motor_types = response.data.data.bike_type;
                }).catch(error => {
                    console.log(error);
                });
    },
    changeMotor(event,label){
      if(event){
        this.form[label] = event._id;
      }else{
        this.form[label] = null;
      }
    },
    getMotors() {
            axios.get(api_url+'/static/motor')
                .then(response => {
                    this.varianMotors =  this.mapOptions(response.data.data.bike_type);
                }).catch(error => {
                    console.log(error);
                });
    },
    getMotorCategory() {
            this.loadderforms = false;
            axios.get(api_url+'/static/motor-category')
                .then(response => {
                    this.motorCategories = response.data.data.category_motor;
                    var others = {
                    title: "Lain-lain",
                    name: "lain-lain",
                    };
                    this.motorCategories.push(others);
                    this.loadderforms = false;
                }).catch(error => {
                    console.log(error);
                });
    },
    changeMotorCategory(event,label,target){
      if(event){
        this.form[target] = '';
        this[target] = '';
        this.form[label] = event.name;
        this.form.motor_category = event.name;
        this.motor_category = event.name;
        if(event.name == 'lain-lain'){
          //  this.getMotors();
        }else{
         this.getVarianMotor(event);
        }
      }
    },
    getVarianMotor(category) {
        axios.get(api_url+'/static/motor?type='+category.name)
            .then(response => {
                this.varianMotors =  this.mapOptions(response.data.data.motor);
            }).catch(error => {
                console.log(error);
            });
    },
    changeVarianMotor(event,label,target){
      if(event){
        var motor = {id : event.id , name : event.title};
        this.form[label] = event.id;
        this[target] = event.title
      }
        // console.log(event);
    },
    getClub() {
            axios.get(api_url+'/static/community')
                .then(response => {
                    this.clubs = response.data.data.community;
                }).catch(error => {
                    console.log(error);
                });
    },
    changeClub(event,label){
        if(event){
            if(event._id){
            this.form[label] = event._id;
            }
          // console.log(label+' == ' + this.form[label])
        }
    },
    newClub(event,label ){
        this.form[label] = event.name;
    },
    mapOptions(data) {
      var items = data.map((item) => {
          return {id:item._id, title:item.name};
      });
      var uniqes = [ ...new Set(items) ];
      return uniqes;
    },
    getParam(param) {
      var url = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
      for (var i=0;i<url.length;i++) {
          var params = url[i].split("=");
          if(params[0] == param)
            return params[1];
      }
      return false;
    },
    uppercaseFirstLetter(string = '') {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
  },
};
</script>
<style lang="scss">
  #registerpage{
    .vue-input-tag-wrapper .input-tag {
      background: #282828;
      border-radius: 10px;
      color: #FFFFFF;
      align-self: center;
      font-style: normal;
      font-weight: 300;
      font-size: 14px;
      line-height: 24px;
      padding: 5px 1rem 5px 1rem !important;
      margin-bottom: 0px;
    }
    @media (max-width: 768px) {
      .vue-input-tag-wrapper .input-tag {
        background: #E61B33;
        line-height: 22px;
        height: 25px;
        padding: 0px 1rem 0px 1rem !important;
      }
    }
  }
</style>
<style scoped lang="scss">
.note {
  padding: 8px 0px;
  display: block;
  font-size: 12px;
  color:#333;
}
.input62{
  color:#333;
}
.text-red {
  color: #e61b33;
}
.colpage{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    .pageform{
        display: flex;
        justify-content: center;
        align-items: center;
        margin:0 20px;
        .numberpage{
            display: block;
            width: 35px; height: 35px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color:#4F4F4F;
            border-radius:100px;
            font-weight: bold;
        }
        .infopage{
            font-weight: bold;
            color:#4F4F4F;
            margin-left: 15px;
        }
    }
    .pageform.active{
        .numberpage{
            background-color:#7AE798;
        }
        .infopage{
            color:#7AE798;
        }
    }
}
#registerpage {
  background: #000000;
  font-family: Manrope;
  .card {
    background: #ffffff;
    border-radius: 10px;
    /* font-family: Inter; */
  }
  .title {
    color: #000000;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    margin-bottom: 1rem;
  }
  .label-form {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 24px;
    color: #3f3f3f;
  }
  .form-register {
    border-radius: 10px;
    border: 1px solid #dbdbdb;
    box-sizing: border-box;
    padding:11px;
    height: auto;
  }
  ::placeholder {
    color: #727272;
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 24px;
  }
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url(/images/arrow-select.png) no-repeat right white;
    background-position-x: 98.5%;
  }
  .form-check {
    font-style: normal;
    font-weight: 300;
    font-size: 14px;
    line-height: 22px;
    color: #000000;
  }

  .btn {
    width: 161px;
    height: 50px;
  }
  .btn-white {
    border: 1px solid #dbdbdb;
    box-sizing: border-box;
    border-radius: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #e61b33;
  }
  a.btn-white{
    display: flex;
    align-items: center;
    justify-content: center;
    }

  .btn-red {
    background: #e61b33;
    border-radius: 10px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: #ffffff;
  }
  .title-row {
    background: #191919;
    opacity: 0.95;
    font-style: normal;
    font-weight: 600;
    font-size: 32px;
    line-height: 42px;
    color: #ffffff;
  }
  .title-row-info {
    background: #1e1e1e;
  }
  .modal-content {
    background: #ffffff;
    border-radius: 10px;
  }
  .modal-header {
    border-bottom: unset;
  }
  .modal-title {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 30px;
    color: #e61b33;
  }
  .breadcrumb-image {
    max-height: 25px;
    display: inline-flex;
  }
  .breadcrumb-image-mobile {
    max-height: 25px;
    display: none;
  }
  .fa {
    cursor: pointer;
  }
  .fa-active {
    color: #4f4f4f;
  }
  .fa-not-active {
    color: #b4b4b4;
  }
  .row-eye {
    right: 35px;
    bottom: 155px;
    position: absolute;
    z-index: 1;
  }
  .row-password-eye {
    right: 35px;
    bottom: 265px;
    position: absolute;
    z-index: 1;
  }
  @media (max-width: 768px) {
    select {
      background-position-x: 95.5%;
    }
    .title {
      font-size: 18px;
    }
    .label-form {
      font-weight: 300;
    }
    .form-register {
      height: 40px;
    }
    .row-password-eye {
      bottom: 240px;
    }
    .row-eye {
      bottom: 145px;
    }
    .btn {
      width: 120px;
    }
    .modal-body {
      padding-left: 1.5rem !important;
      padding-right: 1.5rem !important;
    }
    .breadcrumb-image {
      display: none;
    }
    .breadcrumb-image-mobile {
      display: inline-flex;
    }
  }
}
</style>
